<div class="topbar fixed h-20 left-0 top-0 w-full px-8 flex items-center ">
  <a class="topbar-logo" routerLink="/">
      <img src="/servituno-logo.png" alt="logo">
      <span>{{ title() }}</span>
  </a>
  @if (!profile()) {
    <div class="p-link menu-button topbar-button"></div>
  } @else {
    <div class="menu-button">
      <button
        #menubutton
        pButton
        icon="pi pi-bars"
        [rounded]="true"
        [text]="true"
        class="p-link"
        (click)="sidebar()">
      </button>
    </div>
  }

  <div class="topbar-menu topbar-menu-mobile topbar-menu-mobile-active" [class]="{'topbar-menu-mobile-active': state.profileSidebarVisible}">
    <p-menubar [model]="items" [styleClass]="styleClass">
      <ng-template pTemplate="item" let-item>
        @if (!item.route) {
          <button [class]="item.button">
            <i [class]="item.icon"></i>
            <span>{{ item.label }}</span>
            <span class="pi pi-fw pi-angle-down ml-2"></span>
          </button>
        } @else {
          <button [class]="item.button" [routerLink]="item.route">
            <i [class]="item.icon" [style]="item.i"></i>
            <span [style]="item.span">{{ item.label }}</span>
          </button>
        }
      </ng-template>
    </p-menubar>
  </div>
</div>
